import { Button } from '@bambi/component-library/src/components/Button/Button';
import { DatePicker } from '@bambi/component-library/src/components/inputs/DatePicker/DatePicker';
import { SimpleTooltip } from '@bambi/component-library/src/components/Tooltip/SimpleTooltip';
import {
  CalendarIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
} from '@heroicons/react/24/outline';
import { DateTime } from 'luxon';


import { isSameWeek } from './isSameWeek';

type DateControlsProps = {
  current: DateTime;
  onPrev: () => void;
  onNext: () => void;
  onToday: () => void;
  onDatePicked: (date: DateTime | undefined) => void;
  maxDate?: DateTime;
  minDate?: DateTime;
  prevTooltip: string;
  nextTooltip: string;
};

export function DateControls({
  current,
  onPrev,
  onNext,
  onToday,
  onDatePicked,
  maxDate,
  minDate,
  prevTooltip,
  nextTooltip,
}: DateControlsProps) {
  return (
    <div className="flex gap-1">
      <SimpleTooltip
        trigger={
          <div className="flex">
            <Button
              variant="secondary"
              onClick={onPrev}
              disabled={minDate && isSameWeek(current, minDate)}
              className="rounded-r-none"
              dataTestId="set-prev-day"
            >
              <ChevronLeftIcon className="h-2 w-2 text-gray-900" />
            </Button>
          </div>
        }
        content={prevTooltip}
      />
      <SimpleTooltip
        trigger={
          <div className="flex">
            <Button
              variant="secondary"
              className="flex rounded-none text-gray-900"
              onClick={onToday}
              dataTestId="set-today"
            >
              Today
            </Button>
          </div>
        }
        content={DateTime.local().toFormat('cccc, LLLL d')}
      />
      <SimpleTooltip
        trigger={
          <div className="flex">
            <Button
              variant="secondary"
              onClick={onNext}
              disabled={maxDate && isSameWeek(current, maxDate)}
              className="flex rounded-l-none"
              dataTestId="set-next-day"
            >
              <ChevronRightIcon className="h-2 w-2 text-gray-900" />
            </Button>
          </div>
        }
        content={nextTooltip}
      />
      <DatePicker
        triggerElement={
          <Button variant="ghost" dataTestId="calendar-btn">
            <CalendarIcon className="datepicker-icon h-6 w-6" />
          </Button>
        }
        onChange={onDatePicked}
        maxDate={maxDate}
        minDate={minDate}
        value={current}
      />
    </div>
  );
}
